interface IAbsenceType {
    type: string;
    color: string;
    glyph: string;
    verbose_name: {
        en: string;
        ru: string;
    };
}

export const getAbsenceByType = (type: string): IAbsenceType | undefined => {
    return absenceTypes.find(a => a.type === type);
}

export const absenceTypes: IAbsenceType[] = [{
    "type": "absence",
    "glyph": "gapAbsence",
    "color": "#ffc136",
    "verbose_name": { "ru": "\u041e\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0438\u0435", "en": "Absence" }
}, {
    "type": "remote_work",
    "glyph": "gapHome",
    "color": "#008000",
    "verbose_name": {
        "ru": "\u0423\u0434\u0430\u043b\u0451\u043d\u043d\u0430\u044f \u0440\u0430\u0431\u043e\u0442\u0430",
        "en": "Remote work"
    }
}, {
    "type": "office_work",
    "color": "#122faa",
    "glyph": "gapOffice",
    "verbose_name": {
        "ru": "\u0420\u0430\u0431\u043e\u0442\u0430 \u0432 \u043e\u0444\u0438\u0441\u0435",
        "en": "Office work"
    }
}, {
    "type": "trip",
    "glyph": "gapTrip",
    "color": "#abd46e",
    "verbose_name": {
        "ru": "\u041a\u043e\u043c\u0430\u043d\u0434\u0438\u0440\u043e\u0432\u043a\u0430",
        "en": "Trip"
    }
}, {
    "type": "conference_trip",
    "color": "#abd46e",
    "glyph": "gapTrip",
    "verbose_name": {
        "ru": "\u041a\u043e\u043c\u0430\u043d\u0434\u0438\u0440\u043e\u0432\u043a\u0430 \u043d\u0430 \u043a\u043e\u043d\u0444\u0435\u0440\u0435\u043d\u0446\u0438\u044e",
        "en": "Conference trip"
    }
}, {
    "type": "conference",
    "glyph": "gapTrip",
    "color": "#abd46e",
    "verbose_name": {
        "ru": "\u041a\u043e\u043d\u0444\u0435\u0440\u0435\u043d\u0446\u0438\u044f",
        "en": "Conference"
    }
}, {
    "type": "learning",
    "glyph": "graduationCap",
    "color": "#00c09c",
    "verbose_name": { "ru": "\u041e\u0431\u0443\u0447\u0435\u043d\u0438\u0435", "en": "Learning" }
}, {
    "type": "vacation",
    "glyph": "gapPlane",
    "color": "#73c9eb",
    "verbose_name": { "ru": "\u041e\u0442\u043f\u0443\u0441\u043a", "en": "Vacation" }
}, {
    "type": "paid_day_off",
    "glyph": "gapDayOff",
    "color": "#73c9eb",
    "verbose_name": { "ru": "\u041e\u0442\u0433\u0443\u043b", "en": "Paid day off" }
}, {
    "type": "illness",
    "glyph": "gapSick",
    "color": "#f67360",
    "verbose_name": { "ru": "\u0411\u043e\u043b\u0435\u0437\u043d\u044c", "en": "Illness" }
}, {
    "type": "maternity",
    "glyph": "gapBaby",
    "color": "#dc97ca",
    "verbose_name": {
        "ru": "\u041e\u0442\u043f\u0443\u0441\u043a \u043f\u043e \u0443\u0445\u043e\u0434\u0443",
        "en": "Maternity"
    }
}, {
    "type": "duty",
    "color": "#4260c2",
    "glyph": "gapShield",
    "verbose_name": { "ru": "\u0414\u0435\u0436\u0443\u0440\u0441\u0442\u0432\u043e", "en": "Duty" }
}];
